import { Button, notification } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiVoidTransaction } from "../../../../api/transactions";
import { userHasPermission } from "../../../../helpers/user";
import DisabledWithReason from "../DisabledWithReason/DisabledWithReason";

const BLOCKED_STATUS_MESSAGES = {
  pending: "Estornar venda não é possível, a venda está pendente.",
  canceled: "Estornar venda não é possível, a venda já foi cancelada.",
};

const VoidSaleButton = ({ sale }) => {
  const [voiding, setVoiding] = useState(false);
  const navigate = useNavigate();

  if (!userHasPermission("void_transaction")) {
    return null;
  }

  const supported = Boolean(sale?.capabilities?.void);

  const handleVoid = async () => {
    const blocked = BLOCKED_STATUS_MESSAGES[sale?.status];
    if (blocked) {
      notification.error({ message: "Erro", description: blocked, placement: "topRight" });
      return;
    }
    setVoiding(true);
    try {
      await apiVoidTransaction(sale?.id);
      notification.success({
        message: "Sucesso",
        description: "Venda foi estornada com sucesso!",
        placement: "topRight",
      });
      navigate(`/listagem-vendas`);
    } catch (error) {
      notification.error({
        message: "Erro",
        description:
          error?.status === 500
            ? "Ocorreu um erro no servidor ao estornar a venda. Por favor, tente novamente mais tarde."
            : "Erro ao estornar a venda.",
        placement: "topRight",
      });
    } finally {
      setVoiding(false);
    }
  };

  return (
    <div
      className="container-buttons"
      style={{ marginTop: "20px", display: "flex", justifyItems: "space-between", width: "100%" }}
    >
      <DisabledWithReason disabled={!supported} reason="Estorno ainda não disponível para esta adquirente.">
        <Button onClick={handleVoid} type="primary" danger disabled={!supported} loading={voiding}>
          Estornar venda
        </Button>
      </DisabledWithReason>
    </div>
  );
};

export default VoidSaleButton;
